import type { HomeConfig } from '@/components/subject/configs.ts';

const homeConfig: HomeConfig = {
  experiments: [],
  mindMaps: [],
  thinking: [],
};

export { homeConfig };
